import Cgl from 'Cgl';

const CONTEXT = "@grid/positioncontext";

const getDistance = (p1, p2) => Math.sqrt((p2.X - p1.X) ** 2 + (p2.Y - p1.Y) ** 2);

const _getCell = (point) => {
    const _elements = document.elementsFromPoint(point.X, point.Y);
    
    for (let _element of _elements) {
        if (_element.classList.contains("cmn-grid-layout-cell")) {
            return _element;
        }
    }

    return null;
};

const getCell = (point) => {
    let _cell = _getCell(point);
    if (!_cell) {
        _cell = _getCell({ ...point, X: point.X + 8 })
    }
    return _cell;
};

const getPosition = (point) => {
    const _cell = getCell(point);

    if (!_cell) {
        return null;
    }

    const _dataset = _cell.dataset;
    const _row = Number.parseInt(_dataset.row);
    const _column = Number.parseInt(_dataset.column);

    return {
        Row: _row,
        Column: _column
    };
}

function handlePosition(el, binding) {

    let _layoutMan = binding.value;
    let _point = null;

    const _mousemove = Cgl.Func.PreventRepeatExec(e => {
        
        let _currentPoint = { X: e.pageX, Y: e.pageY };

        const _position = getPosition(_currentPoint);
    
        if (_position) {
            _layoutMan.Context.set("MousePosition", _position);
        }

    }, 0.1);

    const _mouseup = e => {

        _point = null;
        document.removeEventListener("mousemove", _mousemove, { capture: true })
        document.removeEventListener("mouseup", _mouseup);

    };

    const _handle = e => {
        
        // 复制节点
        _point = { X: e.pageX, Y: e.pageY };

        const _cell = getCell(_point);
        if (!_cell) {
            return;
        }

        _layoutMan.Context.set("MousePosition", getPosition(_point));

        document.addEventListener("mousemove", _mousemove, { capture: true });
        document.addEventListener("mouseup", _mouseup);

    };

    if (!el[CONTEXT]) {
        el[CONTEXT] = {
            removeHandle: _handle
        };
    } else {
        el[CONTEXT].removeHandle = _handle;
    }

    return _handle;
}

export default {
    bind(el, binding, vnode) {
        el.addEventListener("mousedown", handlePosition(el, binding), { capture: true });
    },
    update(el, binding) {
        el.removeEventListener("mousedown", el[CONTEXT].removeHandle, { capture: true });
        el.addEventListener("mousedown", handlePosition(el, binding), { capture: true });
    },
    unding(el, binding) {
        el.removeEventListener("mousedown", el[CONTEXT].removeHandle, { capture: true });
    }
}